/**
 * 海报管理
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async saveFormDetail(result) {
    return request(api.market.SPREADPOSTER, METHOD.POST, result);  //保存表单
  },
  async getFormDetail(keyId) {
    return request(api.market.SPREADPOSTER + '/' + keyId, METHOD.GET);
  },
  async getMarketList(searchResult,page) {
    return request(api.market.SPREADPOSTER + '?limit=7&page='+page, METHOD.GET, searchResult);
  },
  async deleteMarketItem(keyId) { // 删除 单个
    return request(api.market.SPREADPOSTER + "/deletePoster?posterId=" + keyId, METHOD.GET);
  },
  async changeStatus(result) {
    return request(api.market.SPREADPOSTER + '/updateStatus', METHOD.GET, result);
  },
  //新增功能   海报分类树结构  2022-07-14
  async getPosterTree() {
    return request(api.answer.COMMONTREE + '?typeNo=CD400005', METHOD.GET);
  },
  //新增功能  海报保存树结构
  async savePosterTreeDetail(result){
    return request(api.answer.SAVETREE + '/saveContentBaseCodeDetail?typeNo=CD400005', METHOD.POST,result);
  },
  //新增功能  删除树结构 通用
  async delTree(codeId){
    return request(api.answer.SAVETREE + '/deleteCarTypeId?codeId=' + codeId, METHOD.GET);
  },
  //新增功能  编辑树结构详情
  async getTreeDetail(codeId) {
    return request(api.answer.SAVETREE + '/getDetailByCodeId?codeId='+codeId, METHOD.GET);
  },
}

export default {dataApi}
